<template>
	<div class="result-area" :class="'result-area-' + identifier + ' result-area-largest-index-' + largestIndex">
		<div class="text-container largest-index-answer">
			{{ hasValues ? labels[largestIndex] : '' }}
		</div>
		<div class="picture">
			<no-drag-image src="@/assets/results/jylland.png" v-if="identifier === 'jylland'"
			               :scale="areaPictureScale"/>
			<no-drag-image src="@/assets/results/fyn.png" v-else-if="identifier === 'funen'" :scale="areaPictureScale"/>
			<no-drag-image src="@/assets/results/sjaelland.png" v-else-if="identifier === 'sealand'"
			               :scale="areaPictureScale"/>
			<no-drag-image src="@/assets/results/bornholm.png" v-else-if="identifier === 'bornholm'"
			               :scale="areaPictureScale"/>
		</div>
		<div class="bottom-bar">
			<div class="result-bars row">
                <div
                        v-for="(percentage, i) in percentages"
                        v-if="hasValues || i === 0"
                        class="result-bar col"
                        :class="['result-bar-' + i, i === largestIndex ? 'result-bar-largest' : null]"
                        :style="{ width: percentage + '%', maxWidth: percentage + '%' }"
                >
                    <span v-if="i === largestIndex">{{ getPercentageText(percentage) }}</span>
                </div>
			</div>
			<div class="bottom-bar-title">
				{{ areaName }}
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'result-area',
		props: {
			index: {
				type: Number,
				required: true
			},
			identifier: {
				type: String,
			},
			percentages: {
				type: Array
			},
			labels: {
				type: Array
			},
			largestIndex: {
				type: Number,
				required: false,
				default: false,
			}
		},
        methods: {
		    getPercentageText(percentage) {
		        return Math.round(percentage) + '%';
            },
        },
		computed: {
			areaName() {
				switch (this.identifier) {
					case 'jylland':
						return 'Jylland';
					case 'funen':
						return 'Fyn';
					case 'sealand':
						return 'Sjælland';
					case 'bornholm':
						return 'Bornholm';
					default:
						return this.identifier;
				}
			},
			hasValues() {
				for (let percentage of this.percentages) {
					if (percentage > 0) {
						return true;
					}
				}

				return false;
			},
		},
		data() {
			return {
				areaPictureScale: .8,
			}
		}
	}
</script>

<style lang="scss" scoped>
	.result-area {
        position: relative;

		.picture {
			text-align: center;
			height: 600px;

			.no-drag-image {
				width: 100%;
				height: 100%;

				img {
					max-height: 100%;
				}
			}
		}

		&.result-area-funen {
			.picture {
				padding-top: 80%;
			}
		}

		&.result-area-sealand {
			.picture {
				padding-top: 55%;
			}
		}

		&.result-area-bornholm {
			.picture {
				padding-top: 90%;
			}
		}

        .text-container {
            position: absolute;

            top: 40%;
            font-size: 40pt;
            font-weight: bold;
            text-align: center;
            width: 100%;
            padding: 0 80px;
        }

        .bottom-bar-title {
            width: 100%;
            font-weight: bold;
            font-size: 30pt;
            text-align: center;
        }

        .bottom-bar {
            position: relative;
            top: -50px;
        }

        .result-bars {
            background: #FF001E;
            height: 50px;
            margin: 50px 80px 0 80px;
	        overflow: hidden;
	        white-space: nowrap;

            .result-bar {
	            flex-basis: auto !important;
                height: 100%;
                color: white;
                font-weight: bold;
                font-size: 25pt;
                padding: 0 10px;

                &.result-bar-0 {
                    background: $bar1color1;
                    text-align: left;
                }

                &.result-bar-1 {
                    background: $bar2color1;
                    text-align: right;
                }

                &.result-bar-2 {
	                background: $bar3color1;
                }
            }
        }
	}

	.largest-index-answer {
		//text-shadow: 2px 2px 3px rgba(0, 0, 0, .6);
	}
</style>
